export const timeOutWarningMessageMilliseconds = 2 * 60 * 1000;
export const timeOutInactivityModalMilliseconds = 5 * 60 * 1000;
export const timeOutIdleUserMinutes = 15;

export const timeoutReloadIntervalMilliseconds = 2 * 1000;
